// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TreeCheckbox_children__KZ6mj {
  margin-top: 8px;
  margin-left: 0.3px;
  margin: 10px 0 10px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.TreeCheckbox_hidden__XC2eq {
  overflow: hidden;
}

.TreeCheckbox_collapse__5eMB9 {
  max-height: 0;
  height: 0;
}

.TreeCheckbox_open__1SPnC {
  height: 100%;
  max-height: 1000px;
}

.TreeCheckbox_iconCollapsed__1sYsq {
  transform: rotate(90deg);
}

.TreeCheckbox_iconExpanded__W\\+AjO {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/_common/components/TreeCheckbox/TreeCheckbox.module.scss"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;AAFF;;AAKA;EACE,YAAA;EACA,kBAAA;AAFF;;AAKA;EACE,wBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n\n.children {\n  margin-top: 8px;\n  margin-left: 0.3px;\n  margin: $margin-m 0 $margin-m $margin-l;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.hidden {\n  overflow: hidden;\n}\n\n.collapse {\n  max-height: 0;\n  height: 0;\n}\n\n.open {\n  height: 100%;\n  max-height: 1000px;\n}\n\n.iconCollapsed {\n  transform: rotate(90deg);\n}\n\n.iconExpanded {\n  transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"children": `TreeCheckbox_children__KZ6mj`,
	"hidden": `TreeCheckbox_hidden__XC2eq`,
	"collapse": `TreeCheckbox_collapse__5eMB9`,
	"open": `TreeCheckbox_open__1SPnC`,
	"iconCollapsed": `TreeCheckbox_iconCollapsed__1sYsq`,
	"iconExpanded": `TreeCheckbox_iconExpanded__W+AjO`
};
export default ___CSS_LOADER_EXPORT___;
